<template>
	<el-dialog title="我的收款配置" :visible="visible" width="480px" append-to-body
		:close-on-click-modal="false" @close="onClose">
		<div class="swd-body" v-loading="loading">
			<div class="swd-tip">
				<i class="el-icon-info"></i>
				<span>支付宝接单与微信接单可同时开启；微信接单需先选择发送方式（发二维码图片 或 发微信号，二选一必选）才能开启。</span>
			</div>

			<!-- 支付宝接单开关 -->
			<div class="swd-section">
				<div class="swd-alipay-active">
					<span class="swd-alipay-label">支付宝接单：</span>
					<el-switch :value="!!alipay.isActive" active-color="#1677ff"
						@change="onAlipayToggle"></el-switch>
					<span v-if="alipay.isActive" class="swd-tag swd-tag-blue">接单中</span>
					<span v-else class="swd-tag-off">未接单(不派单)</span>
				</div>
				<div class="swd-sub-tip">开启后，分配订单时系统自动给买家发送支付宝收款提示。</div>
			</div>

			<!-- 微信接单(二维码图/微信号二选一) -->
			<div class="swd-section">
				<div class="swd-alipay-active">
					<span class="swd-alipay-label">微信接单：</span>
					<el-switch :value="!!wechat.isActive" active-color="#07c160"
						@change="onWechatToggle"></el-switch>
					<span v-if="wechat.isActive" class="swd-tag">接单中</span>
					<span v-else class="swd-tag-off">未接单(不派单)</span>
				</div>
				<div class="swd-sendtype">
					<span class="swd-sendtype-label"><i style="color:#f56c6c;font-style:normal">*</i> 给买家发送：</span>
					<el-radio-group v-model="wechat.sendType" size="small">
						<el-radio :label="1" @change="onChangeSendType">二维码图片</el-radio>
						<el-radio :label="2" @change="onChangeSendType">微信号</el-radio>
					</el-radio-group>
				</div>
				<div v-if="wechat.sendType !== 2" class="swd-qr">
					<file-upload :action="'/image/upload'" :isPermanent="true" :maxSize="5 * 1024 * 1024"
						:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']" :showLoading="true"
						@success="onQrUploadOk" @fail="onQrUploadFail">
						<div class="swd-qr-box">
							<img v-if="wechat.qrcodeUrl" :src="wechat.qrcodeUrl" class="swd-qr-img" />
							<template v-else>
								<i class="el-icon-plus"></i>
								<span>上传企业微信二维码</span>
							</template>
						</div>
					</file-upload>
					<div class="swd-qr-tip">开启后，分配订单时系统自动给买家发送「微信不接受转账请发红包」和这张二维码图，买家扫码加好友。更换二维码直接重新上传覆盖。</div>
				</div>
				<div v-if="wechat.sendType === 2" class="swd-wxno">
					<!-- 2026-08-29 商用需求: 业务员可无限制添加多个微信号, 列表管理,
						任选一条开启接单(换号防封场景) -->
					<div class="swd-wxlist">
						<div v-for="item in wechatList" :key="item.id" class="swd-wxitem">
							<span class="swd-wxitem-no" :title="item.remark || ''">{{ item.wechatNo }}<em v-if="item.remark">（{{ item.remark }}）</em></span>
							<span v-if="item.isActive" class="swd-tag">接单中</span>
							<el-button v-if="!item.isActive" size="mini" type="success" @click="onWxListActive(item)">设为接单</el-button>
							<el-button v-else size="mini" @click="onWxListActive(item)">停用</el-button>
							<el-button size="mini" type="danger" plain icon="el-icon-delete" @click="onWxListDelete(item)"></el-button>
						</div>
						<div v-if="!wechatList.length" class="swd-wxempty">还没有添加微信号，请在下方添加</div>
					</div>
					<div class="swd-wxadd">
						<el-input v-model="newWechatNo" placeholder="输入微信号" maxlength="32" size="small" style="width:180px"></el-input>
						<el-input v-model="newWechatRemark" placeholder="备注(选填，如:备用号)" maxlength="100" size="small" style="width:180px"></el-input>
						<el-button type="primary" size="small" @click="onAddWechatNo">添加微信号</el-button>
					</div>
					<div class="swd-wxno-tip">可无限制添加多个微信号，点“设为接单”选择当前生效的一个（换号防封）；开启后分配订单时系统只给买家发一条「请加这个微信号：xxx」提示，买家手动添加好友。</div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import bizApi from "../../api/bizApi.js";
import FileUpload from "../common/FileUpload.vue";

export default {
	name: "chatSalesWechatDialog",
	components: { FileUpload },
	props: {
		visible: { type: Boolean, default: false }
	},
	data() {
		return {
			loading: false,
			alipay: { isActive: false },
			wechat: { id: null, qrcodeUrl: '', wechatNo: '', sendType: null, isActive: false },
			// 微信号模式下的全量列表(业务员可无限添加,逐条开启/删除)
			wechatList: [],
			newWechatNo: '',
			newWechatRemark: ''
		};
	},
	watch: {
		visible(v) {
			if (v) {
				this.load();
			}
		}
	},
	methods: {
		load() {
			this.loading = true;
			Promise.all([bizApi.alipayMine(), bizApi.wechatMine()]).then(([alipay, wlist]) => {
				this.alipay = { isActive: !!(alipay && alipay.isActive) };
				// 后端按接单开关优先排序,取第一行即生效配置行;微信号列表另行全量展示(仅微信号模式的行)
				const list = (wlist || []).filter((w) => w.sendType !== 1);
				this.wechatList = list;
				const w = list[0] || (wlist || [])[0] || null;
				this.wechat = {
					id: w ? w.id : null,
					qrcodeUrl: w && w.qrcodeUrl ? w.qrcodeUrl : '',
					wechatNo: w && w.wechatNo ? w.wechatNo : '',
					// 历史行 sendType 为空: 有二维码的按二维码模式展示; 有多个微信号行的按微信号模式展示
					sendType: w && w.sendType ? w.sendType : (w && w.qrcodeUrl ? 1 : (list.length > 1 ? 2 : null)),
					isActive: !!(w && w.isActive)
				};
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.loading = false;
			});
		},
		onAlipayToggle(val) {
			bizApi.alipaySetActive(val).then(() => {
				this.$message.success(val ? '已开启支付宝接单，可被派单' : '已关闭支付宝接单');
				// 两模式可并存,重载两侧状态
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '操作失败');
			});
		},
		onQrUploadOk(data) {
			const url = data && data.originUrl;
			if (!url) {
				this.$message.error('上传失败，请重试');
				return;
			}
			bizApi.wechatSetQrcode(url).then((w) => {
				this.$message.success('企业微信二维码已保存，发送方式已选定为二维码图片');
				this.wechat.id = w.id;
				this.wechat.qrcodeUrl = url;
				this.wechat.sendType = w.sendType || 1;
			}).catch((e) => {
				this.$message.error(e.message || '二维码保存失败');
			});
		},
		onQrUploadFail() {
			this.$message.error('二维码图片上传失败，请重试');
		},
		onChangeSendType(val) {
			// v-model 已同步 wechat.sendType,这里只做落库与提示
			if (val === 1) {
				if (!this.wechat.qrcodeUrl) {
					// 上传二维码时后端自动落 sendType=1
					this.$message.info('请上传企业微信二维码完成设置');
					return;
				}
				bizApi.wechatSetSendType(1).then((w) => {
					this.$message.success('发送方式已切换为二维码图片');
					this.wechat.id = w.id;
				}).catch((e) => {
					this.$message.error(e.message || '设置失败');
					this.load();
				});
			} else if (val === 2) {
				if (!this.wechat.wechatNo) {
					this.$message.info('请填写微信号并点保存，完成设置后才能开启微信接单');
				}
			}
		},
		onSaveWechatNo() {
			const no = (this.wechat.wechatNo || '').trim();
			if (!no) {
				this.$message.warning('请输入微信号');
				return;
			}
			bizApi.wechatSetSendType(2, no).then((w) => {
				this.$message.success('微信号已保存，发送方式已选定为微信号');
				this.wechat.id = w.id;
				this.wechat.sendType = 2;
				this.wechat.wechatNo = w.wechatNo || no;
			}).catch((e) => {
				this.$message.error(e.message || '微信号保存失败');
			});
		},
		// ---------- 多微信号列表管理(无限添加/切换接单/删除) ----------
		onAddWechatNo() {
			const no = (this.newWechatNo || '').trim();
			if (!no) {
				this.$message.warning('请输入微信号');
				return;
			}
			bizApi.wechatSave({ wechatNo: no, remark: (this.newWechatRemark || '').trim() }).then((w) => {
				this.$message.success('微信号已添加');
				this.newWechatNo = '';
				this.newWechatRemark = '';
				// 首条添加即选定发送方式为微信号并自动开启接单,减少操作步骤
				if (!this.wechatList.length) {
					bizApi.wechatSetSendType(2, no).then(() => bizApi.wechatSetActive(w.id, true)).then(() => {
						this.wechat.sendType = 2;
						this.load();
					}).catch((e) => {
						this.$message.error(e.message || '开启接单失败');
						this.load();
					});
				} else {
					this.load();
				}
			}).catch((e) => {
				this.$message.error(e.message || '添加失败');
			});
		},
		onWxListActive(item) {
			const target = !item.isActive;
			bizApi.wechatSetActive(item.id, target).then(() => {
				this.$message.success(target ? '已开启该微信号接单，可被派单' : '已停用该微信号接单');
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '操作失败');
			});
		},
		onWxListDelete(item) {
			this.$confirm('确定删除微信号 ' + item.wechatNo + ' ？', '提示', { type: 'warning' }).then(() => {
				bizApi.wechatDelete(item.id).then(() => {
					this.$message.success('已删除');
					this.load();
				}).catch((e) => {
					this.$message.error(e.message || '删除失败');
				});
			}).catch(() => { });
		},
		onWechatToggle(val) {
			if (val) {
				if (!this.wechat.sendType) {
					this.$message.warning('请先选择发送方式（二维码图片 或 微信号），必须二选一');
					return;
				}
				if (this.wechat.sendType === 2 && !(this.wechat.wechatNo || '').trim()) {
					this.$message.warning('请先填写微信号并保存');
					return;
				}
				if (this.wechat.sendType === 1 && !this.wechat.qrcodeUrl) {
					this.$message.warning('请先上传企业微信二维码');
					return;
				}
				if (!this.wechat.id) {
					this.$message.warning('请先完成发送方式设置');
					return;
				}
			}
			bizApi.wechatSetActive(this.wechat.id, val).then(() => {
				this.$message.success(val ? '已开启微信接单，可被派单' : '已关闭微信接单');
				// 两模式可并存,重载两侧状态
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '操作失败');
			});
		},
		onClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="css" scoped>
.swd-body {
	min-height: 120px;
}

.swd-tip {
	display: flex;
	align-items: flex-start;
	gap: 6px;
	background: #ecf5ff;
	color: #5a8dc8;
	border-radius: 6px;
	padding: 8px 12px;
	font-size: 13px;
	line-height: 1.6;
	margin-bottom: 12px;
}

.swd-tip i {
	margin-top: 3px;
}

.swd-section {
	border: 1px solid #ebeef5;
	border-radius: 8px;
	padding: 12px;
	margin-bottom: 12px;
}

.swd-section:last-child {
	margin-bottom: 0;
}

.swd-alipay-active {
	display: flex;
	align-items: center;
	gap: 8px;
	background: #f7f9fc;
	border-radius: 6px;
	padding: 10px 12px;
}

.swd-alipay-label {
	font-size: 14px;
	color: #303133;
}

.swd-sub-tip {
	font-size: 12px;
	color: #909399;
	margin-top: 8px;
	line-height: 1.6;
}

.swd-tag {
	display: inline-block;
	background: #07c160;
	color: #fff;
	font-size: 11px;
	border-radius: 8px;
	padding: 1px 7px;
	margin-left: 6px;
}

.swd-tag-blue {
	background: #1677ff;
}

.swd-tag-off {
	color: #909399;
	font-size: 12px;
}

.swd-qr {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	margin-top: 10px;
}

.swd-qr-box {
	width: 120px;
	height: 120px;
	border: 1px dashed #c0c4cc;
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
	color: #909399;
	font-size: 12px;
	cursor: pointer;
	overflow: hidden;
	background: #fafafa;
}

.swd-qr-box:hover {
	border-color: #07c160;
	color: #07c160;
}

.swd-qr-img {
	width: 120px;
	height: 120px;
	object-fit: contain;
}

.swd-qr-tip {
	flex: 1;
	font-size: 12px;
	color: #909399;
	line-height: 1.7;
}

.swd-sendtype {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 10px;
	padding: 8px 12px;
	background: #f7f9fc;
	border-radius: 6px;
}

.swd-sendtype-label {
	font-size: 13px;
	color: #303133;
}

.swd-wxno {
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.swd-wxlist {
	max-height: 180px;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.swd-wxitem {
	display: flex;
	align-items: center;
	gap: 8px;
	background: #f7f9fc;
	border-radius: 6px;
	padding: 6px 10px;
}

.swd-wxitem-no {
	flex: 1;
	font-size: 13px;
	color: #303133;
	word-break: break-all;
}

.swd-wxitem-no em {
	font-style: normal;
	color: #909399;
	font-size: 12px;
}

.swd-wxempty {
	font-size: 12px;
	color: #909399;
	padding: 4px 2px;
}

.swd-wxadd {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.swd-wxno-tip {
	width: 100%;
	font-size: 12px;
	color: #909399;
	line-height: 1.7;
}
</style>
